import { render } from "./ColorDropdown.vue?vue&type=template&id=3b6be9e2&scoped=true"
import script from "./ColorDropdown.vue?vue&type=script&lang=js"
export * from "./ColorDropdown.vue?vue&type=script&lang=js"

import "./ColorDropdown.vue?vue&type=style&index=0&id=3b6be9e2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6be9e2"]])

export default __exports__